var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"content-wrapper"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('horizontalBanner',{attrs:{"edit":_vm.edit,"text":_vm.json.data['text'],"image":_vm.json.data.image}})],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }